import {Alert, Grid} from '@mui/material';
import React, {useState} from 'react';
import {useLimitesContraparte} from "../../sistema/sistemas/contraparte/hooks/useLimites";
import LimiteContraparte from './LimiteContraparte';
import {QueryStatus} from "../../../types";
import {OperacionContraparteLimitesAprobadosPaisFields} from "../../sistema/sistemas/contraparte/types/fields";
import {SistemaTipo} from "../../../types/enum/enum";
import {FiltrosBusqueda, FormFiltros, FormFiltrosFields, schemaFiltrosBusqueda} from "../FiltrosBusqueda";

interface LimitesContraparteProps {

}

function LimitesContraparte({}: LimitesContraparteProps) {
    const [apiFiltros, setApiFiltros] = useState<FormFiltros>(
        schemaFiltrosBusqueda.parse({})
    );

    const {limites, status} = useLimitesContraparte(apiFiltros);

    const handleFilterChange = (nuevosFiltros: FormFiltros) => {
        setApiFiltros(nuevosFiltros);
    };

    return (
        <Grid container gap={10}>
            <Grid item xs={12} sx={{mb: -5}}>
                <FiltrosBusqueda
                    formFields={[
                        FormFiltrosFields.Pais,
                        FormFiltrosFields.NumeroCuenta,
                        FormFiltrosFields.RazonSocial,
                        FormFiltrosFields.SectorComercial
                    ]}
                    mensajeTipo={SistemaTipo.CLG}
                    onFilterChange={handleFilterChange}
                />
            </Grid>

            {
                limites &&
                limites.map(l => (
                    <Grid item container xs={12} gap={5}
                          key={l[OperacionContraparteLimitesAprobadosPaisFields.CodPais]}>
                        <Grid item xs={12}>
                            <LimiteContraparte
                                data={l}
                                loading={status === QueryStatus.Loading}
                                error={status === QueryStatus.Error}
                            />
                        </Grid>
                    </Grid>
                ))
            }
            <Grid item xs={12}>
                {
                    (!limites?.length && status === QueryStatus.Success) &&
                    <Alert severity="warning">No se encontraron datos.</Alert>
                }
            </Grid>
        </Grid>
    );
}

export default LimitesContraparte;
